<lovers-popup [exibir]="abrirModal()" (onClose)="fecharCard()" tamanho="grande">
  <div class="popup__header pb-4">
    <p class="header__title">Locais disponíveis</p>
  </div>
  <div class="popup__body">
    <div class="descricao">
      <div class="row w-100">
        <div class="col-lg-8 col-md-8 col-sm-12 col-12">
          <div class="map-container">
            <div class="map-frame">
              <div id="map"></div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12 col-12 div__infos_mapa">
          <div class="col-12 pl-1">
            <p><b>Busque por locais próximos ao seu</b></p>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-5 col-5 pr-2">
              <div class="lovers-input__container">
                <!-- <label for="cep" class="lovers-label">CEP</label> -->
                <input
                  #cep
                  type="text"
                  class="lovers-input"
                  placeholder="Seu CEP"
                  mask="00.000-000"
                  name="cep"
                  id="cep"
                />
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-5 col-5">
              <div class="lovers-input__container pr-0 pl-0">
                <!-- <label for="numero" class="lovers-label">NUMERO</label> -->
                <input
                  #numero
                  type="text"
                  class="lovers-input"
                  placeholder="Número"
                  name="numero"
                  id="numero"
                />
              </div>
            </div>
            <div class="col-2 pl-0 pr-0" style="padding-top: 6px">
              <button
                [disabled]="habilitarBotaoPesquisa()"
                class="lovers-button"
                (click)="buscarEndereco()"
              >
                <img
                  class="filtro__icone img__btn_search"
                  src="assets/images/icons/pesquisar.png"
                />
              </button>
            </div>
          </div>
          <div class="col-12 pt-3 pb-3">
            <a class="lbl__localizacao" (click)="obterLocalizacaoAtual()">
              <img
                class="opcao__icone"
                style="width: 14px; height: 14px"
                src="assets/images/icons/mapa.png"
              />
              &nbsp; Usar minha localização atual
            </a>
          </div>

          <div class="container__card__localizacao">
            <div
              class="card-localizacao mb-3"
              *ngFor="let item of listaEndereco"
              (click)="irParaEndereco(item.latitude, item.longitude)"
            >
              <div class="div__nome_parceiro">
                <p class="mb-0 lbl__nome_mapa">
                  {{ item.descricao !== null ? item.descricao : item.nome }}
                </p>
              </div>
              <p class="mb-0 lbl__endereco_mapa">
                {{ item.logradouro }}, {{ item.numero }}
              </p>
              <p class="mb-2 lbl__endereco_mapa">
                {{ item.estado }} {{ item.cep }}
              </p>

              <div class="lbl__info__localizacao">
                <p
                  class="lbl__detalhes mb-1"
                  (click)="redirectGoogleMaps(item.latitude, item.longitude)"
                >
                  Detalhes <i class="icon__arrow fa fa-chevron-right"></i>
                </p>
                <p
                  class="lbl__raio"
                  (click)="redirectGoogleMaps(item.latitude, item.longitude)"
                >
                  <img
                    class="opcao__icone"
                    style="width: 11.5px; height: 15px"
                    src="assets/images/icons/location_red.png"
                  />
                  {{ this.formatarValorParaDuasCasasDecimais(item.distancia) }}
                  km
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</lovers-popup>
